/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react'
import axiosInstance from '../../../../../_metronic/layout/core/axiosInterceptor'
import {useNavigate} from 'react-router-dom'

import './ViewReschedule.css'

import axios from 'axios'
import dayjs from 'dayjs'
import {Table, Tag, PaginationProps, Spin, Pagination, DatePicker} from 'antd'
import type {ColumnsType} from 'antd/es/table'
import {LoadingOutlined} from '@ant-design/icons'
import {Row, Col, Form, FormGroup, Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBook, faPen, faSearch} from '@fortawesome/free-solid-svg-icons'
import {formatDate, formatDateWithTimeZone} from '../../../../../_metronic/helpers'

const {RangePicker} = DatePicker

type Props = {
  className: string
}

interface DataType {
  reschedule_id: number
  order_id: number
  store_name: string
  date_order: string
  member_id: number
  member_name: string
  phone_number: number
  payment_status: string
  order_status: string
  reschedule_status: string
  order_status_label: string
  reschedule_status_label: string
}

const ViewRescheduleCS: React.FC<Props> = ({className}) => {
  const apiUrl = process.env.REACT_APP_API_URL
  const navigate = useNavigate()

  const userRole = localStorage.getItem('userRole') as string
  const userStore = localStorage.getItem('storeId') as number | null
  const userVendor = localStorage.getItem('vendor_id') as number | null
  const userTukang = localStorage.getItem('tukang_id') as number | null

  const storeId = userStore !== null ? `&store_id=${userStore}` : ''
  const vendorId = userVendor !== null ? `&vendor_id=${userVendor}` : ''
  const tukangId = userTukang !== null ? `&tukang_id=${userTukang}` : ''

  const [loadingButton, setLoadingButton] = useState<boolean>(false)
  const [loadData, setLoadData] = useState<boolean>(true)

  const [rescheduleData, setRescheduleData] = useState<DataType[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalData, setTotalData] = useState<number>(0)

  const [dateFrom, setDateFrom] = useState<any>(new Date().toISOString().split('T')[0])
  const [dateTo, setDateTo] = useState<any>(new Date().toISOString().split('T')[0])
  const [searchFilter, setSearchFilter] = useState<string>('')

  const handleChangeSearchFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedSearchFilter = event.target.value
    setSearchFilter(updatedSearchFilter)
  }

  const today = new Date()
  const formatDate = (date: any) => {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  const renderTooltip = (title: string) => <Tooltip id='button-tooltip'>{title}</Tooltip>

  const columns: ColumnsType<DataType> = [
    {
      title: 'Reschedule ID',
      dataIndex: 'reschedule_id',
      key: 'reschedule_id',
      align: 'center',
      width: 110,
      sorter: (a, b) => a.reschedule_id - b.reschedule_id,
    },
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      key: 'order_id',
      align: 'center',
      className: 'col_order_id',
      defaultSortOrder: 'descend',
      width: 'fit-content',
      sorter: (a, b) => a.order_id - b.order_id,
    },
    {
      title: 'Nama Toko',
      dataIndex: 'store_name',
      key: 'store_name',
      align: 'center',
      width: 'fit-content',
      onFilter: (value, record) => record.store_name.includes(String(value)),
      sorter: (a, b) => a.store_name.length - b.store_name.length,
    },
    {
      title: 'Tanggal Order',
      dataIndex: 'date_order',
      key: 'date_order',
      align: 'center',
      width: 'fit-content',
      onFilter: (value, record) => record.date_order.includes(String(value)),
      sorter: (a, b) => a.date_order.length - b.date_order.length,
    },
    {
      title: 'Nama Customer',
      dataIndex: 'member_name',
      key: 'member_name',
      align: 'left',
      width: 'fit-content',
      onFilter: (value, record) => record.member_name.includes(String(value)),
      sorter: (a, b) => a.member_name.length - b.member_name.length,
    },
    {
      title: 'No Telp / WA',
      dataIndex: 'phone_number',
      key: 'phone_number',
      align: 'center',
      width: 'fit-content',
      sorter: (a, b) => a.phone_number - b.phone_number,
    },
    {
      title: 'Payment Status',
      dataIndex: 'payment_status',
      key: 'payment_status',
      align: 'left',
      width: 'fit-content',
      onFilter: (value, record) => record.payment_status.includes(String(value)),
      sorter: (a, b) => a.payment_status.length - b.payment_status.length,
    },
    {
      title: 'Status Order',
      dataIndex: 'order_status_label',
      key: 'order_status_label',
      align: 'left',
      width: 'fit-content',
      render: (order_status) => {
        const orderStatus = order_status
        let color = ''

        switch (orderStatus) {
          case 'BOOK':
            color = 'green'
            break
          case 'BOOKED':
            color = 'lime'
            break
          case 'SURVEYREQ':
            color = 'blue'
            break
          case 'SURVEYSTART':
          case 'SURVEYDONE':
          case 'QUOTE IN':
          case 'QUOTE OUT':
          case 'WORKREQ':
          case 'WORKSTART':
          case 'WORKEND':
          case 'CISOUT':
            color = 'green'
            break
          default:
            color = 'blue'
            break
        }

        return <Tag color={color}>{orderStatus}</Tag>
      },
      onFilter: (value, record) => record.order_status_label.includes(String(value)),
      sorter: (a, b) => a.order_status_label.length - b.order_status_label.length,
    },
    {
      title: 'Status Reschedule',
      dataIndex: 'reschedule_status_label',
      key: 'reschedule_status_label',
      align: 'left',
      width: 'fit-content',
      render: (reschedule_status) => {
        const rescheduleStatus = reschedule_status
        let color = ''

        switch (rescheduleStatus) {
          case 'RESCHEDULEAPPROVEDBYVENDOR':
            color = 'green'
            break
          case 'RESCHEDULEAPPROVEDBYHO':
            color = 'lime'
            break
          case 'RESCHEDULEREJECTEDBYVENDOR':
          case 'RESCHEDULEREJECTEDBYHO':
            color = 'red'
            break
          default:
            color = 'blue'
            break
        }

        return <Tag color={color}>{rescheduleStatus}</Tag>
      },
      onFilter: (value, record) => record.reschedule_status_label.includes(String(value)),
      sorter: (a, b) => a.reschedule_status_label.length - b.reschedule_status_label.length,
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 'fit-content',
      render: (record) => {
        const handleEdit = () => {
          const id = record.reschedule_id
          navigate(`/reschedule/update-reschedule/${id}`)
        }

        return (
          <div className='button-wrapper d-flex justify-content-center align-items-center'>
            <OverlayTrigger
              placement='bottom'
              delay={{show: 250, hide: 400}}
              overlay={renderTooltip('Update Reschedule')}
            >
              <Button variant='primary' className='button-edit' onClick={handleEdit}>
                <FontAwesomeIcon
                  className='text-white'
                  icon={['Store CS', 'Tukang'].includes(userRole) ? faBook : faPen}
                  fontSize={'13px'}
                />
              </Button>
            </OverlayTrigger>
          </div>
        )
      },
    },
  ]

  const fetchRescheduleList = async (page: number, pageSize: number, queryparams: any) => {
    let apiUrlWithParams = `${apiUrl}/reschedule?order_by=desc&page=${page}&take=${pageSize}&date_from=${dateFrom}&date_to=${dateTo}${storeId}${vendorId}${tukangId}${queryparams}`

    try {
      const response = await axiosInstance.get(apiUrlWithParams, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        //  // 'Access-Control-Allow-Origin': '*',
        // // 'ngrok-skip-browser-warning':  'true',
        },
      })

      setCurrentPage(response.data.page)
      setTotalData(response.data.takeTotal ?? 0)
      setLoadData(false)

      return response.data.data
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const ViewReschedule = async (page: number, pageSize: number, queryparams: any) => {
    try {
      const apiData = await fetchRescheduleList(page, pageSize, queryparams)

      if (!apiData) {
        console.error('No data received from fetchRescheduleList')
        return []
      }

      const rescheduleData = apiData.map((item: any) => {
        let data

        const orderDate = formatDateWithTimeZone(item?.created_at)

        const phoneNumber = item?.order?.project_number.startsWith('0')
          ? item?.order?.project_number
          : `+62${item?.order?.project_number}`

        const paymentStatus = (() => {
          if (item?.order?.payment_type === 'survey') {
            return item?.order.receipt_number === null ? 'UNPAID' : 'PAID'
          } else if (item?.order?.payment_type === 'gratis') {
            return 'FREE'
          } else if (item?.order?.payment_type === 'pemasangan_tanpa_survey') {
            return item?.order.receipt_number === null ? 'UNPAID' : 'PAID'
          } else {
            return ''
          }
        })()

        data = {
          reschedule_id: item?.id,
          order_id: item?.order_id,
          store_name: item?.order?.store.store_name,
          date_order: orderDate,
          member_id: item?.order?.members.member_number,
          member_name: item?.order?.members.full_name,
          phone_number: phoneNumber,
          payment_status: paymentStatus,
          order_status: item?.order?.status?.category,
          reschedule_status: item?.reschedule_status[0]?.status?.category,
          order_status_label: item?.order?.status?.description,
          reschedule_status_label: item?.reschedule_status[0]?.status?.description,
        }

        return data
      })

      return rescheduleData
    } catch (error) {
      console.error('Error getting reschedule list data:', error)
      return []
    }
  }

  const fetchData = async (page: number, pageSize: number, queryparams: any) => {
    const data = await ViewReschedule(page, pageSize, queryparams)
    setRescheduleData(data)
  }

  useEffect(() => {
    fetchData(1, 10, '')
  }, [])

  const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a>Prev</a>
    }
    if (type === 'next') {
      return <a>Next</a>
    }
    return originalElement
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleSubmitFilter()
    }
  }

  const handleSubmitFilter = async () => {
    setLoadingButton(true)
    let queryparams = ``

    const valueCheck = (key: any, value: any) => {
      if (value !== null && value !== undefined && value !== '' && value !== 0) {
        queryparams += `${key}${value}`
      }
    }

    valueCheck(`&search=`, searchFilter)

    const data = await ViewReschedule(1, 10, queryparams)
    setRescheduleData(data)

    setLoadingButton(false)
  }

  return (
    <section id='view-reschedule'>
      <div className={`card ${className}`}>
        <div className='card-body'>
          <Row className='table-head-wrapper'>
            <div
              className='d-flex flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row flex-xxl-row align-items-start align-items-sm-center align-items-md-center align-items-lg-center align-items-xl-center align-items-xxl-center justify-content-start gap-3'
              onKeyDown={handleKeyPress}
            >
              <h3 className='d-flex align-items-center fs-5 fw-normal'>Date</h3>

              <RangePicker
                format={'DD-MM-YYYY'}
                className='date-range'
                defaultValue={[
                  dayjs(`${formatDate(today)}`, 'DD-MM-YYYY'),
                  dayjs(`${formatDate(today)}`, 'DD-MM-YYYY'),
                ]}
                onChange={(values) => {
                  if (values && values.length === 2) {
                    const dateFromFormatted = values[0]?.format('YYYY-MM-DD')
                    const dateToFormatted = values[1]?.format('YYYY-MM-DD')

                    setDateFrom(dateFromFormatted)
                    setDateTo(dateToFormatted)
                  } else {
                    setDateFrom(new Date().toISOString().split('T')[0])
                    setDateTo(new Date().toISOString().split('T')[0])
                  }
                }}
              />

              <div className='filter-search'>
                <FormGroup>
                  <Form.Control
                    placeholder='Search'
                    className='filter-ltr'
                    onChange={handleChangeSearchFilter}
                  />

                  <span className='search-icon'>
                    <FontAwesomeIcon icon={faSearch} className='text-black' size='sm' />
                  </span>
                </FormGroup>
              </div>

              <Button
                className='btn-dark-primary button-submit m-0'
                disabled={loadingButton}
                onClick={handleSubmitFilter}
              >
                {loadingButton ? 'Filtering..' : 'Submit'}
              </Button>
            </div>
          </Row>

          <Spin
            tip='Loading...'
            spinning={loadData}
            size='large'
            indicator={<LoadingOutlined style={{fontSize: 24}} spin />}
          >
            <div className='table-custom-wrapper'>
              <Table
                className='table-striped-rows'
                bordered
                columns={columns}
                dataSource={rescheduleData}
                rowKey={(record) => record.reschedule_id}
                pagination={false}
                sticky={true}
                tableLayout='auto'
                scroll={{x: 1700}}
              />
            </div>
          </Spin>

          <div className='pagination-container mt-5'>
            <span className='total-text'>
              Showing {(currentPage - 1) * pageSize + 1} -{' '}
              {Math.min(currentPage * pageSize, totalData)} of {totalData} Reschedule
            </span>

            <Pagination
              className='pagination'
              current={currentPage}
              total={totalData}
              showSizeChanger
              pageSizeOptions={[5, 10, 20, 50, 100]}
              itemRender={itemRender}
              onShowSizeChange={(current, size) => {
                setPageSize(size)
              }}
              onChange={(page, pageSize) => {
                fetchData(page, pageSize, '')
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export {ViewRescheduleCS}
